module.exports = __webpack_public_path__ + "img/item(11).74beccb4.svg";